<template>
  <div>
    <headd :mobile_title="mobile_title"></headd>

    <div class="report container">
      <div class="select" v-if="companys.length > 0">
        <select @change="getCompanysSelected($event)"
          ><option v-for="item in companys" :value="item.credit_code">{{
            item.company_title
          }}</option></select
        >
      </div>
      <div style="margin:0 0.32rem;font-size:20px;text-align:center">
        申报时间
      </div>
      <div class="select" v-if="month.length > 0">
        <select @change="getMonthsSelected($event)"
          ><option v-for="item in month" :value="item">{{
            item
          }}</option></select
        >
      </div>
      <div class="list" v-if="fileJson.length > 0">
        <div class="item" v-for="(item, index) in fileJson">
          <div class="name">{{ month_item }}记账申报</div>
          <div class="btn" @click="goView(www + item.filepath)">点击查看</div>
        </div>
      </div>

      <div class="dbox_upload" @click="onUpload" v-show="fileJson.length < 1">
        <div class="upload">
          <img src="../../../static/order/icon_2.png" />
        </div>
        <div class="upload_text">点击这里上传</div>
        <!-- <view class="upload_tip">支持扩展名gif|jpg|png|jpeg|doc|docx|xls|xlsx|pdf|zip|rar</view> -->
      </div>

      <div class="btn_fixedd" @click="addreport">提交</div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { Loading } from "element-ui";
let inputElement = null;
import headd from "@/components/head";
import axios from "axios";
import foot from "@/components/foot";
import {
  getcwjizhangPage,
  getcwJizhangQuery,
  getcwJizhangDeclare
} from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "立即申报",
      localPath: "",
      tip: "",
      index: 0,
      index2: 0,
      month: [],
      companys: [],
      fileJson: [],
      Declare: {},
      credit_code: "",
      month_item: "",
      www: this.common.www_img,
      apiurl: this.common.apiurl
    };
  },
  mounted() {
    this.myjizhanglist();
  },
  components: {
    headd,
    foot
  },
  methods: {
    async myjizhanglist() {
      var _self = this;
      var data = {
        uid: localStorage.getItem("userId")
      };
      const res = await getcwjizhangPage(data);
      //_self.month = res.data.data.month
      _self.month = ["请选择", ...res.data.data.month];
      _self.companys = [
        {
          credit_code: "请选择",
          company_title: "请选择"
        },
        ...res.data.data.companys
      ];
    },
    async myJizhangQueryList() {
      var _self = this;
      const res = await this.$myRuquest({
        url: "/cwJizhangQuery",
        method: "GET",
        data: {
          uid: uni.getStorageSync("userinfo").id,
          credit_code: _self.credit_code
        }
      });
      console.log(res);
      _self.jizhangDeatils = res.data.data.jizhangDeatils;
    },
    getCompanysSelected(e) {
      var _self = this;

      _self.credit_code = e.target.value;
      //_self.myJizhangQueryList();
    },
    getMonthsSelected(e) {
      var _self = this;

      _self.month_item = e.target.value;
      //_self.myJizhangQueryList();
    },
    bindPickerChange(e) {
      var _self = this;
      var index = e.detail.value;
      console.log(e);
      _self.index = index;
      _self.month_item = _self.month[index];
    },

    goView(urlnew) {
      let url = urlnew;
      //console.log(url);
      window.open(url, "_blank");
    },

    /* 上传 */
    onUpload() {
      var that = this;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }

        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    uploadFile(el) {
      var _self = this;
      var loadingInstance1 = Loading.service({ fullscreen: true });
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        console.log(el);
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 50;
        const size = files.size / 1024 / 1024;
        //console.log(size);
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$toast("上传文件大小不能超过 50MB!");
        }
        // else if (files.type.indexOf("image") === -1) {
        //   //如果不是图片格式
        //   // this.$dialog.toast({ mes: '请选择图片文件' });
        //   this.$message.error("请选择图片文件");
        // }
        else {
          const that = this;
          const reader = new FileReader(); // 创建读取文件对象
          console.log(el.target.files[0]);
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            // 文件读取完成后
            // 读取完成后，将结果赋值给img的src
            that.valueUrl = this.result;
            //console.log(_self.dataURLtoBlob(this.result));

            // 数据传到后台
            const formData = new FormData();
            formData.append("jizhangfile", files, files.name); // 通过append向form对象添加数据,可以通过append继续添加数据//或formdata1.append('img',file);
            let config = {
              headers: { "Content-Type": "multipart/form-data" }
            };
            axios
              .post(that.apiurl + "/uploadjizhangFile", formData, config)
              .then(uploadFileRes => {
                //console.log(uploadFileRes.data);
                var res = uploadFileRes.data;
                console.log(res.data);
                if (res.status == 1) {
                  that.fileJson.push(uploadFileRes.data.data);
                } else {
                  that.$toast(res.msg);
                }

                that.$nextTick(() => {
                  // 以服务的方式调用的 Loading 需要异步关闭
                  loadingInstance1.close();
                });
                inputElement = null;
              });
          };
        }
      }
    },

    async addreport() {
      var _self = this;

      if (_self.credit_code == "") {
        this.$toast("请选择公司");

        return false;
      }
      if (_self.month_item == "") {
        this.$toast("请选择申报时间");

        return false;
      }
      if (_self.fileJson.length == 0) {
        this.$toast("请上传文件");

        return false;
      }

      var parm = {
        uid: localStorage.getItem("userId"),
        credit_code: _self.credit_code,
        month: _self.month_item,
        filepathJson: JSON.stringify(_self.fileJson)
      };
      console.log(parm);
      const res = await getcwJizhangDeclare(parm);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        setTimeout(() => {
          _self.$router.push({
            path: "report_manage"
          });
        }, 2000);
      }
    }
  },
  onShow() {
    this.myjizhanglist();
  }
};
</script>

<style lang="less" scoped>
.report {
  flex-direction: column;

  .select {
    margin: 0.37rem auto;
    width: 6.26rem;
    height: 0.7rem;
    background: rgba(196, 196, 204, 0.19);
    border-radius: 0.35rem;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.3rem;
    font-size: 0.3rem;
    color: #1b1c33;
    .icon {
      width: 0.3rem;
      height: 0.17rem;
    }
    select {
      width: 100%;
      height: 100%;
      border: none;
      background: transparent;
      font-size: 0.2rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
    }
  }

  .list {
    flex-direction: column;
    width: 6.26rem;
    margin: auto;

    .item {
      padding: 0rem;
      width: ~"calc(100%)";
      height: 0.8rem;
      align-items: center;
      justify-content: space-between;
      border-bottom: 0.01rem solid #eeeeee;
      display: flex;

      .name {
        font-size: 0.2rem;
        color: #1b1c33;
        margin-right: 0.35rem;
        @media (max-width: 991px) {
          font-size: 0.28rem;
        }
      }

      .btn {
        font-size: 0.2rem;
        color: #1395ff;
        @media (max-width: 991px) {
          font-size: 0.26rem;
        }
      }
    }
  }

  .list_nodata {
    margin: 2.5rem 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .nodata_icon {
      width: 3.83rem;
      height: 2.72rem;
      margin-bottom: 0.6rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .nodata_text {
      font-size: 0.3rem;
      color: #8d8e99;
      line-height: 0.3rem;
      letter-spacing: 0.01rem;
    }
  }

  .btn_fixedd {
    margin: 0.6rem auto;
    width: 3rem;
    height: 0.7rem;
    line-height: 0.7rem;
    border-radius: 0.35rem;
    text-align: center;
    align-items: center;
    justify-content: center;
    background-color: #1395ff;
    color: #fff;
    font-size: 0.3rem;
    z-index: 10;
  }

  .dbox_upload {
    margin: 0 auto;
    width: 6.06rem;
    height: 2.92rem;
    background: rgba(196, 196, 204, 0.1);
    border-radius: 0.22rem;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    display: flex;

    .upload {
      width: 1rem;
      height: 0.83rem;
      margin-bottom: 0.23rem;

      img {
        width: 1rem;
        height: 0.83rem;
      }
    }

    .upload_text {
      height: 0.42rem;
      font-size: 0.24rem;
      color: #1b1c33;
      line-height: 0.42rem;
    }

    .upload_tip {
      height: 0.42rem;
      font-size: 0.3rem;
      color: #8d8e99;
      line-height: 0.42rem;
    }
  }

  .dbox_cell {
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.4rem;

    .dbox_name {
      width: 1.25rem;
      height: 0.42rem;
      font-size: 0.3rem;
      color: #5e5e66;
      line-height: 0.42rem;
      text-align: justify;
      display: inline-block;
      text-align-last: justify;
    }

    .dbox_input {
      width: 4.63rem;
      .input {
        width: 3.83rem;
        height: 0.42rem;
        line-height: 0.42rem;
        padding: 0.12rem 0.4rem;
        background: rgba(196, 196, 204, 0.1);
        border-radius: 0.12rem;
        font-size: 0.3rem;
        color: #c4c4cc;
      }

      .textarea {
        width: 3.83rem;
        height: 1.2rem;
        line-height: 0.42rem;
        padding: 0.12rem 0.4rem;
        background: rgba(196, 196, 204, 0.1);
        border-radius: 0.12rem;
        font-size: 0.3rem;
        color: #c4c4cc;
      }

      .select {
        width: 100%;
        height: 0.42rem;
        border: 0;
        background-color: rgba(196, 196, 204, 0.1);
        align-items: center;
        justify-content: flex-start;
        padding: 0.12rem 0.2rem;
        border-radius: 0.12rem;
      }
    }

    .dbox_upload {
      width: ~"calc(100% - 0.4rem)";
      height: auto;
      padding: 0.3rem 0.2rem;
      background: rgba(196, 196, 204, 0.1);
      border-radius: 0.22rem;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      background-size: cover;
      background-position: center;
      font-size: 0.26rem;

      .upload {
        width: 1rem;
        height: 0.83rem;
        margin-bottom: 0.23rem;

        img {
          width: 1rem;
          height: 0.83rem;
        }
      }

      .upload_text {
        height: 0.42rem;
        font-size: 0.3rem;
        color: #1b1c33;
        line-height: 0.42rem;
      }

      .upload_tip {
        height: 0.42rem;
        font-size: 0.3rem;
        color: #8d8e99;
        line-height: 0.42rem;
      }

      .delete {
        position: absolute;
        top: -0.15rem;
        right: -0.15rem;
        width: 0.4rem;
        height: 0.4rem;
        z-index: 2;
      }
    }

    .img_list {
      width: 6.46rem;
      padding: 0.22rem 0.2rem;
      height: auto;
      background: #f9f9f9;
      border-radius: 0.2rem;
      flex-wrap: wrap;

      .img_item {
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 0.2rem;
        margin-right: 0.5rem;
        margin-bottom: 0.3rem;
        background-color: #ffffff;
        align-items: center;
        justify-content: center;
        border: 0.01rem solid #979797;
        position: relative;
        background-position: center;
        background-size: cover;
        display: flex;

        .delete {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          width: 0.4rem;
          height: 0.4rem;
          z-index: 2;
        }

        .img {
          width: 1.2rem;
          height: 1.2rem;
          border-radius: 0.2rem;
          opacity: 0;
        }

        .item_icon {
          width: 0.5rem;
          height: 0.48rem;
        }

        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/report/add_report.vue